import Vue from "vue";
const http = Vue.prototype.$http;

export async function index() {

  const response = await Vue.prototype.$http.get("/payment_types");

  return response.data;
}
